import axios from 'axios'
import {getCookie} from '../../../../../utils/cookie'
import type {EkycVerifyRequest} from '../../../../wizards/types'

const API_URL = process.env.REACT_APP_API_BASE_URL
const API_KEY: any = process.env.REACT_APP_API_KEY
// export const REGISTER_URL = `${API_URL}/v1/ekyc/account/status`
export const VNPT_VERIFY = `${API_URL}/v1/ekyc/vnpt-verify`

// const checkStatusAccount = async (data: any) => {
//   const response = await axios.post(REGISTER_URL, data, {
//     headers: {
//       'x-api-key': API_KEY,
//       'Access-Control-Allow-Origin': '*',
//     },
//   })
//   return response.data
// }

const vnptVerify = async (data: EkycVerifyRequest) => {
  const response = await axios.post(VNPT_VERIFY, data, {
    headers: {
      'x-api-key': API_KEY,
      'Access-Control-Allow-Origin': '*',
      'session-id': getCookie('SESSION_ID'),
    },
  })
  return response.data
}

export default vnptVerify
